export default [{
    'navLabel': '首页',
    'linkUrl': 'home',
    'linkType': 1,
    'navSubList': [{
        'navLabel': '首页',
        'linkUrl': 'home',
        'linkType': 1
      },
      {
        'navLabel': '前沿资讯',
        'linkUrl': 'news',
        'linkType': 2
      },
      {
        'navLabel': '齿科学院',
        'linkUrl': 'school',
        'linkType': 2
      },
      // {
      //   'navLabel': '在线商城',
      //   'linkUrl': 'mall',
      //   'linkType': 2
      // },
    ]
  },
  {
    'navLabel': 'Online设计平台',
    'linkUrl': 'order/create',
    'linkType': 1,
    'navSubList': [{
        'navLabel': '创建服务单',
        'linkUrl': 'order/create',
        'linkType': 1
      },
      {
        'navLabel': '我的服务单',
        'linkUrl': 'order/dem',
        'linkType': 1
      }
    ]
  },
  {
    'navLabel': 'AI视觉',
    'navIcon': '',
    'linkUrl': 'ai',
    'linkType': 1,
    // 'navSubList': [{
    //     'navLabel': '全部',
    //     'linkUrl': 'news',
    //     'linkType': 1
    //   }, {
    //     'navLabel': '新闻资讯',
    //     'linkUrl': 'news',
    //     'query': {
    //       'cataType': '1'
    //     },
    //     'linkType': 9
    //   },
    //   {
    //     'navLabel': '行业动态',
    //     'linkUrl': 'news',
    //     'query': {
    //       'cataType': '2'
    //     },
    //     'linkType': 9
    //   }
    // ]
  },
  {
    'navLabel': '医小智商城',
    'linkUrl': 'mall',
    'linkType': 1,
    'navSubList': [{
    		'navLabel': '全部',
    		'linkUrl': 'mall',
    		'linkType': 1
    	},
    	{
    		'navLabel': '口扫设备',
    		'linkUrl': 'mall',
    		'query': {
    		  'cataType': '1'
    		},
    		'linkType': 9
    	},
    	{
    		'navLabel': '工具配件',
    		'linkUrl': 'mall',
    		'query': {
    		  'cataType': '2'
    		},
    		'linkType': 9
    	},
      {
      	'navLabel': '其他',
      	'linkUrl': 'mall',
      	'query': {
      	  'cataType': '9'
      	},
      	'linkType': 9
      }
    ]
  },
  {
    'navLabel': '软件中心',
    'linkUrl': 'school',
    'linkType': 1,
    'navSubList': [{
        'navLabel': '全部',
        'navIcon': '',
        'linkUrl': 'school',
        'linkType': 1
      },
      {
        'navLabel': '知识中心',
        'linkUrl': 'school',
        'query': {
          'cataType': '1'
        },
        'linkType': 9
      },
      {
        'navLabel': '解决方案',
        'linkUrl': 'school',
        'query': {
          'cataType': '2'
        },
        'linkType': 9
      },
      {
        'navLabel': '相关案例',
        'linkUrl': 'school',
        'query': {
          'cataType': '3'
        },
        'linkType': 9
      },
      {
        'navLabel': '产品手册',
        'linkUrl': 'school',
        'query': {
          'cataType': '4'
        },
        'linkType': 9
      }
    ]
  },
  {
    'navLabel': '产品介绍',
    'linkUrl': 'school',
    'linkType': 1,
    'navSubList': [{
        'navLabel': '全部',
        'navIcon': '',
        'linkUrl': 'school',
        'linkType': 1
      },
      {
        'navLabel': '知识中心',
        'linkUrl': 'school',
        'query': {
          'cataType': '1'
        },
        'linkType': 9
      },
      {
        'navLabel': '解决方案',
        'linkUrl': 'school',
        'query': {
          'cataType': '2'
        },
        'linkType': 9
      },
      {
        'navLabel': '相关案例',
        'linkUrl': 'school',
        'query': {
          'cataType': '3'
        },
        'linkType': 9
      },
      {
        'navLabel': '产品手册',
        'linkUrl': 'school',
        'query': {
          'cataType': '4'
        },
        'linkType': 9
      }
    ]
  },
  {
    'navLabel': '齿科学院',
    'linkUrl': 'school',
    'linkType': 1,
    'navSubList': [{
        'navLabel': '全部',
        'navIcon': '',
        'linkUrl': 'school',
        'linkType': 1
      },
      {
        'navLabel': '知识中心',
        'linkUrl': 'school',
        'query': {
          'cataType': '1'
        },
        'linkType': 9
      },
      {
        'navLabel': '解决方案',
        'linkUrl': 'school',
        'query': {
          'cataType': '2'
        },
        'linkType': 9
      },
      {
        'navLabel': '相关案例',
        'linkUrl': 'school',
        'query': {
          'cataType': '3'
        },
        'linkType': 9
      },
      {
        'navLabel': '产品手册',
        'linkUrl': 'school',
        'query': {
          'cataType': '4'
        },
        'linkType': 9
      }
    ]
  },
  {
    'navLabel': '行业新闻',
    'linkUrl': 'news',
    'linkType': 1,
    'navSubList': [{
        'navLabel': '全部',
        'linkUrl': 'news',
        'linkType': 1
      }, {
        'navLabel': '新闻资讯',
        'linkUrl': 'news',
        'query': {
          'cataType': '1'
        },
        'linkType': 9
      },
      {
        'navLabel': '行业动态',
        'linkUrl': 'news',
        'query': {
          'cataType': '2'
        },
        'linkType': 9
      }
    ]
  },
    {
      'navLabel': '联系我们',
      'linkUrl': 'school',
      'linkType': 1,
      'navSubList': [{
          'navLabel': '全部',
          'navIcon': '',
          'linkUrl': 'school',
          'linkType': 1
        },
        {
          'navLabel': '知识中心',
          'linkUrl': 'school',
          'query': {
            'cataType': '1'
          },
          'linkType': 9
        },
        {
          'navLabel': '解决方案',
          'linkUrl': 'school',
          'query': {
            'cataType': '2'
          },
          'linkType': 9
        },
        {
          'navLabel': '相关案例',
          'linkUrl': 'school',
          'query': {
            'cataType': '3'
          },
          'linkType': 9
        },
        {
          'navLabel': '产品手册',
          'linkUrl': 'school',
          'query': {
            'cataType': '4'
          },
          'linkType': 9
        }
      ]
    },
]



// WEBPACK FOOTER //
// ./src/assets/config/navList.js